module.exports = __webpack_public_path__ + "img/info_20_red.5a2fbf9f.svg";